import { render, staticRenderFns } from "./ViewTicket.vue?vue&type=template&id=bfd73ef4&scoped=true"
import script from "./ViewTicket.vue?vue&type=script&lang=js"
export * from "./ViewTicket.vue?vue&type=script&lang=js"
import style0 from "./ViewTicket.vue?vue&type=style&index=0&id=bfd73ef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd73ef4",
  null
  
)

export default component.exports